import React from "react";
import { connect } from "react-redux";
import { login, fetchLogin } from "../actions/actions";
import { loginKeychain } from "../actions/keychain";
import { loginWithWif } from "../helpers/steem";
import backend from "../api/backend";
import Cookies from "universal-cookie";

class LoginParking extends React.Component {
  state = {
    username: "",
    postingKey: "",
    error: "",
    loadingWif: false,
    loadingKeychain: false,
    showKey: false,
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, error: "" });
  };

  toggleShowKey = () => {
    this.setState((prev) => ({ showKey: !prev.showKey }));
  };

  handleLoginWif = async (e) => {
    e.preventDefault();
    const { username, postingKey } = this.state;

    if (!username.trim()) {
      this.setState({ error: "Please enter your Steem username." });
      return;
    }
    if (!postingKey.trim()) {
      this.setState({ error: "Please enter your Private Posting Key." });
      return;
    }

    this.setState({ loadingWif: true, error: "" });

    try {
      const result = await loginWithWif(username, postingKey);
      if (result.success) {
        const cleanUser = result.username;
        const cookies = new Cookies();
        const next_week = new Date();
        next_week.setDate(next_week.getDate() + 14);

        cookies.set("username", cleanUser, { path: "/", expires: next_week });
        cookies.set("token", "wif_auth", { path: "/", expires: next_week });
        cookies.set("type", "wif", { path: "/", expires: next_week });

        // Register / sync with backend
        await backend.post("/auth/user", {
          username: cleanUser,
          token: "wif_auth",
          type: "wif",
        });

        // Trigger Redux session fetch
        this.props.fetchLogin();
      } else {
        this.setState({ error: result.message || "Invalid credentials." });
      }
    } catch (err) {
      console.error("WIF login error:", err);
      this.setState({ error: err?.response?.data?.message || err?.message || "An error occurred while logging in with Private Key." });
    } finally {
      this.setState({ loadingWif: false });
    }
  };

  handleLoginKeychain = async () => {
    let { username } = this.state;
    username = username ? username.trim().toLowerCase().replace("@", "") : "";

    if (!username) {
      username = prompt("Enter your Steem username:")?.replace("@", "").trim();
    }
    if (!username) return;

    this.setState({ loadingKeychain: true, error: "" });

    try {
      const response = await loginKeychain(username);
      if (response.success) {
        const cookies = new Cookies();
        const next_week = new Date();
        next_week.setDate(next_week.getDate() + 14);

        cookies.set("username", username, { path: "/", expires: next_week });
        cookies.set("token", "keychain_auth", { path: "/", expires: next_week });
        cookies.set("type", "keychain", { path: "/", expires: next_week });

        // Register / sync with backend
        await backend.post("/auth/user", {
          username,
          token: "keychain_auth",
          type: "keychain",
        });

        // Trigger Redux session fetch
        this.props.fetchLogin();
      } else {
        this.setState({ error: response.message || "Keychain login failed." });
      }
    } catch (err) {
      console.error("Keychain login error:", err);
      this.setState({ error: "Keychain login failed or was cancelled." });
    } finally {
      this.setState({ loadingKeychain: false });
    }
  };

  render() {
    document.body.classList.add("bg");
    const { username, postingKey, error, loadingWif, loadingKeychain, showKey } = this.state;

    return (
      <div className="wrapper fadeInDown">
        <div id="formContent" style={{ maxWidth: "420px", padding: "30px 25px 20px" }}>
          <div className="fadeIn first" style={{ marginBottom: "15px" }}>
            <img
              src="./logo.png"
              alt="Steem Ways"
              style={{ width: "130px", marginBottom: "5px" }}
            />
            <h5 style={{ margin: "5px 0 15px", color: "#001d46", fontWeight: "600" }}>
              Steem Ways
            </h5>
          </div>

          {error && (
            <div className="alert alert-danger py-2" style={{ fontSize: "13px", marginBottom: "15px" }}>
              {error}
            </div>
          )}

          {/* Form for Private Posting Key */}
          <form onSubmit={this.handleLoginWif} style={{ textAlign: "left" }}>
            <div className="form-group mb-2">
              <label style={{ fontSize: "12px", fontWeight: "bold", color: "#555", marginBottom: "3px" }}>
                Username
              </label>
              <div className="input-group input-group-sm">
                <div className="input-group-prepend">
                  <span className="input-group-text" style={{ background: "#f0f2f5" }}>@</span>
                </div>
                <input
                  type="text"
                  name="username"
                  className="form-control"
                  placeholder="username"
                  value={username}
                  onChange={this.handleInputChange}
                  autoComplete="username"
                  autoCapitalize="none"
                />
              </div>
            </div>

            <div className="form-group mb-3">
              <label style={{ fontSize: "12px", fontWeight: "bold", color: "#555", marginBottom: "3px" }}>
                Private Posting Key
              </label>
              <div className="input-group input-group-sm">
                <input
                  type={showKey ? "text" : "password"}
                  name="postingKey"
                  className="form-control"
                  placeholder="5J... or Master Password"
                  value={postingKey}
                  onChange={this.handleInputChange}
                  autoComplete="current-password"
                />
                <div className="input-group-append">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={this.toggleShowKey}
                    style={{ fontSize: "11px" }}
                  >
                    {showKey ? "Hide" : "Show"}
                  </button>
                </div>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-block btn-sm"
              disabled={loadingWif}
              style={{
                backgroundColor: "#0200da",
                borderColor: "#0200da",
                fontWeight: "600",
                padding: "8px",
              }}
            >
              {loadingWif ? "Verifying..." : "Log in with Posting Key"}
            </button>
          </form>

          {/* Divider */}
          <div style={{ display: "flex", alignItems: "center", margin: "18px 0" }}>
            <div style={{ flex: 1, height: "1px", background: "#e0e0e0" }} />
            <span style={{ margin: "0 10px", color: "#888", fontSize: "11px", textTransform: "uppercase" }}>
              OR
            </span>
            <div style={{ flex: 1, height: "1px", background: "#e0e0e0" }} />
          </div>

          {/* Keychain Login Button */}
          <button
            type="button"
            className="btn btn-outline-dark btn-block btn-sm"
            onClick={this.handleLoginKeychain}
            disabled={loadingKeychain}
            style={{
              borderColor: "#ccc",
              fontWeight: "600",
              padding: "8px",
            }}
          >
            {loadingKeychain ? "Waiting for Keychain..." : "Log in with Steem Keychain"}
          </button>

          <p style={{ paddingTop: 20, marginBottom: 0, fontSize: 12, color: "#666" }}>
            Brought to you by{" "}
            <a
              href="https://steemitwallet.com/~witnesses"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#0200da", fontWeight: "bold" }}
            >
              @seven.wit
            </a>
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ logged_user: state.user });
export default connect(mapStateToProps, { login, fetchLogin })(LoginParking);
